import React from 'react'
import PropTypes from 'prop-types'
import { Formik, Form, Field } from 'formik'
import { SubmitButton, ButtonArea } from 'lp-components'
import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
  acknowledged: Yup.boolean()
    .oneOf([true], 'You must acknowledge the disclaimer to proceed.')
    .required(),
})

function CustomDisclaimerForm({ disclaimerText, initialValues, onSubmit }) {
  const alreadyAcknowledged = !!initialValues?.tenantApplication?.customDisclaimerAcknowledged

  return (
    <Formik
      initialValues={{ acknowledged: alreadyAcknowledged }}
      validationSchema={validationSchema}
      onSubmit={async (_values, { setSubmitting }) => {
        await onSubmit()
        setSubmitting(false)
      }}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          {disclaimerText && (
            <div
              className="card p-4 mb-4"
              dangerouslySetInnerHTML={{ __html: disclaimerText }}
            />
          )}
          <div className="form-check mb-4">
            <Field
              type="checkbox"
              name="acknowledged"
              id="acknowledged"
              className="form-check-input"
            />
            <label className="form-check-label ms-2" htmlFor="acknowledged">
              I have read and acknowledge the above disclaimer.
            </label>
            {errors.acknowledged && touched.acknowledged && (
              <div className="invalid-feedback d-block">{errors.acknowledged}</div>
            )}
          </div>
          <ButtonArea>
            <SubmitButton submitting={isSubmitting}>Next</SubmitButton>
          </ButtonArea>
        </Form>
      )}
    </Formik>
  )
}

CustomDisclaimerForm.propTypes = {
  disclaimerText: PropTypes.string,
  initialValues: PropTypes.shape({
    tenantApplication: PropTypes.shape({
      customDisclaimerAcknowledged: PropTypes.string,
    }),
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default CustomDisclaimerForm
